import { useContext } from 'react';
import { storefrontInfoContext } from './storefront-info-context';

export function useStorefrontInfo() {
  const storefrontInfo = useContext(storefrontInfoContext);
  if (!storefrontInfo) {
    throw new Error(
      'storefrontInfo value is undefined. Make sure you use the StorefrontInfoProvider before using the context.'
    );
  }
  return storefrontInfo;
}
